<template>
  <section v-if="listAvailableLayouts.length > 0">
    <div 
      v-for="(item, index) in listAvailableLayouts" 
      :key="item.id" 
      @mouseenter="hoverStyle = item.id"
      @mouseleave="hoverStyle = null"
    >
      <div class="styles-item" @click="handleEditStyle(item, index)">
        <div :class="['styles-item-icon']" :style="`background-color: ${item.bg['background-color']};`">
          <v-icon size="15" :color="item.title.color">fa-regular fa-palette</v-icon>
        </div>

        <span>{{item.label || `Estilo ${index + 1}`}}</span>

        <!-- Pop Menu  -->
        <div class="active-section-menu">
          <transition>
            <PopUpMenu
              :visible="showMenuFromStyle.id === item.id || item.id === hoverStyle"
              :options="menuOptions"
              @click="handleStyleOptions(item.id, index)"
              @clickOutside="() => { showMenuFromStyle.id = null }"
            >
            <div :class="['active-section-options', {'isSectionMenuOpened': showMenuFromStyle.id === item.id}]">
              <v-icon size="12">fa-regular fa-ellipsis</v-icon>
            </div>
            </PopUpMenu>  
          </transition>              
        </div>
        <!-- End Pop Menu  -->
      </div>
    </div>

    <RenameDialog 
      type="style"
      objectKey="label"
      :objectToRename="styleToRename"
      :isOpen="isRenameDialogOpen"
      @onClose="isRenameDialogOpen = false"
    />

    <ConfirmDialog 
      v-model="isDeleteDialogOpen"
      title="Remoção de estilo"
      :showTitleDivider="false"
      @confirmDone="confirmRemoveStyle(styleToDeleteIndex.id, styleToDeleteIndex.index)"
    >
    <template v-if="styleToDeleteIndex && styleToDeleteIndex.id" slot="content">
      <div class="pt-2 pb-5">
        Deseja remover o estilo <b>{{getStyleName()}}</b>? <br>Essa ação não poderá ser desfeita.
      </div>
    </template>
    </ConfirmDialog>            
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { generateId } from '../../../helpers/generateId'
import PopUpMenu from '../../_v2/ui/PopUpMenu.vue'
import ConfirmDialog from '../../_v2/ui/ConfirmDialog.vue'
import RenameDialog from './RenameDialog.vue'

export default {
  name: 'MenuStyles',
  components: { PopUpMenu, RenameDialog, ConfirmDialog },
  computed: {
    ...mapGetters(['infos']),

    listAvailableLayouts () {
      return this.infos.layout.length > 0 ? 
        this.infos.layout.filter(item => item.id !== 'default-style').map((item, index) => ({...item, label: item.label || `Estilo ${index + 1}`}))
        :
        []
    },

    menuOptions () {
    const {id, index} = this.showMenuFromStyle
    return [
      {label: 'Renomear', action: () => { this.renameStyle(id, index) }},  
      {label: 'Duplicar seção', action: () => { this.duplicateStyle(id, index) }},
      {label: 'Remover', action: () => { this.removeStyle(id, index) }, divider: true}
    ]
  }  
  },

  data: () => ({
    showMenuFromStyle: {id: null, index: null},
    isRenameDialogOpen: false,
    hoverStyle: null,
    styleToRename: null,
    isDeleteDialogOpen: false,    
    styleToDeleteIndex: null,
  }),

  methods: {
    handleEditStyle (item, index) {
      this.$store.dispatch('setLayoutStyle', {open: true, id: item.id})
      this.$store.dispatch('setNav', {open: true, sectionId: 'style-config'})
    },

    handleStyleOptions (id, index) {
      if (this.showMenuFromStyle.id === id) {
        this.showMenuFromStyle.id = null
        this.showMenuFromStyle.index = null
        return
      }
      this.showMenuFromStyle.id = id
      this.showMenuFromStyle.index = index
    },

    renameStyle(id, index) {
      const styleIndex = index + 1
      this.styleToRename = this.infos.layout[styleIndex]
      this.isRenameDialogOpen = true
    },

    duplicateStyle(id, index) {
      const styleIndex = index + 1
      const styleCopy = JSON.parse(JSON.stringify(this.infos.layout[styleIndex]))
      styleCopy.label = styleCopy.label ? `${styleCopy.label} cópia` : `Estilo ${styleIndex + 1} cópia`
      styleCopy.id = generateId()
      this.infos.layout.splice(index + 2, 0, styleCopy)
    },

    removeStyle(id, index) {
      this.styleToDeleteIndex = {index: index + 1, id} // need to add +1, because index 0, cant be removed because it's default style.
      this.isDeleteDialogOpen = true
    },

    getStyleName () {
      if (!this.styleToDeleteIndex) return ''

      const layout = this.infos.layout[this.styleToDeleteIndex.index]
      const name = layout.label || `Estilo ${this.styleToDeleteIndex.index}`
      return name
    },    

    confirmRemoveStyle(id, index) {
      const styleIndex = index
      this.infos.sections.forEach((section) => {
        if (section.idLayout === id) section.idLayout = ""
      })
      this.infos.layout.splice(styleIndex, 1)
      this.styleToDeleteIndex = null
    }
  }
}
</script>

<style scoped>
  .styles-item {
    display: flex;
    gap: 10px;
    height: 36px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding-left: 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .styles-item span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .styles-item:hover {
    background-color: rgba(102, 109, 128, 0.05);
    cursor: pointer;
  }

  .styles-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background-color: rgba(102, 109, 128, 0.1);
  }

  .active-section-menu {
    display: flex;
    flex: 1;
    justify-content: end;
    padding-right: 12px;
  }

  .active-section-menu /deep/ .active-section-options {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    padding: 2px;
    transition: all 0.3s;
    border-radius: 4px
  }

  .active-section-options:hover {
    background-color: #CBCBCE;
  }

  .isSectionMenuOpened {
    background-color: #CBCBCE;
  }    
</style>